import { State } from './types';

const initialState: State = {
	activities: [],
	errors: []
};

export default initialState;
